import pdfMake from 'pdfmake';
import handlePurchase from "@/services/modules/purchase";
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const pdfFontFamilies = {
    Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
    },
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
pdfMake.fonts = pdfFontFamilies;

const POChallanPdfPrinter = () => {
    const {currencyToWord} = handlePurchase();
    const exportToPDF = (company, product, barcode, qrcode, userName, btnFunc, customizationFields = []) => {
        pdfMake.fonts = pdfFontFamilies;
        const tableItems = product.general
        var doc = {
            pageSize: 'A4',
            pageMargins: [ 60, 100, 60, 80 ],
            header: getHeader(company, customizationFields),
            footer: getFooter(userName, qrcode, customizationFields),
            content: getContent(product, tableItems, barcode, btnFunc, customizationFields),

            styles : {
                header: {
                    fontSize: 24,
                    bold: true,
                    font: 'Roboto'
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'Roboto'
            },
            info: {
                title: product.challan_number
            },
            // Define fonts
            fonts: {
                Roboto: {
                    normal: 'Roboto-Regular.ttf',
                    bold: 'Roboto-Bold.ttf',
                    italics: 'Roboto-Italic.ttf',
                    bolditalics: 'Roboto-BoldItalic.ttf'
                }
            }
        }

        pushIntoTable(doc, product, tableItems, btnFunc, customizationFields)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }
    const formatDate = (date) => {
        var formattedDate = date.toISOString().split('T')[0];
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var amOrPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;
        return formatToDdMmYy(formattedDate) + ' ' + formattedTime
    }
    const formatToDdMmYy = (date) => {
        var dat = date.split('-');
        return `${dat[2]}-${dat[1]}-${dat[0]}`;
    }
    const getHeader = (company, customizationFields) => {
        return {
            margin: [ 60, 25, 60, 10 ],
            columns: [
                (customizationFields['heading_left_logo'] && company.logo64)
                    ? {
                        alignment: 'left',
                        image: company.logo64,
                        maxHeight: 60
                    }
                    : null,

                {
                    alignment: 'right',
                    stack: [
                        (customizationFields['heading_right_company_name'] && company.name) ? company.name : '',
                        (customizationFields['heading_right_company_address'] && company.address) ? 'Address: ' + company.address : '',
                        (customizationFields['heading_right_company_phone'] && company.phone) ? 'Phone: ' + company.phone : '',
                        (customizationFields['heading_right_company_email'] && company.email) ? 'E-mail: ' + company.email : '',
                    ]
                }
            ]
        }
    }
    const getContent = (product, tableItems, barcode, btnFunc, customizationFields) => {
        const profileItems = product.contact ? product.contact.profile_items : [];
        const buyerName = product.buyer ? product.buyer.name : null;
        return  [
            {
                text: 'DELIVERY CHALLAN',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
            },

            {
                margin: [0, 20, 0, 0],
                alignment: 'justify',
                columns: [
                    {
                        width: '50%',
                        stack: [
                            (customizationFields['body_top_left_contact_name'] && product.contact) ? {
                                text: 'Customer Details: ' + product.contact.name,
                                color: 'black',
                                bold: true,
                            } : '',

                            (customizationFields['body_top_left_address']) ? {
                                text: getProfileItemByField(profileItems, 'address'),
                            } : '',

                            (customizationFields['body_top_left_billing_address']) ? {
                                text: getProfileItemByField(profileItems, 'billing_address'),
                            } : '',

                            (customizationFields['body_top_left_contact_address'] && product.contact && product.contact.address) ? {
                                text: product.contact.address,
                            } : '',

                            (customizationFields['body_top_left_buyer_name'] && buyerName != null) ? {
                                text: 'Buyer Name: ' + buyerName,
                                color: 'black',
                            } : '',

                            (customizationFields['body_top_left_country'] && product.sales_order && product.sales_order.country != null) ? {
                                text: 'Country Of Origin: ' + product.sales_order.country,
                                color: 'black',
                            } : '',

                            (customizationFields['body_top_left_loading_port'] && product.sales_order && product.sales_order.loading_port != null) ? {
                                text: 'Loading Port: ' + product.sales_order.loading_port,
                                color: 'black',
                            } : '',

                            (customizationFields['body_top_left_delivery_port'] && product.sales_order && product.sales_order.delivery_port != null) ? {
                                text: 'Delivery Port: ' + product.sales_order.delivery_port,
                                color: 'black',
                            } : '',
                        ]
                    },

                    {
                        width: '50%',
                        alignment: 'right',
                        stack: [
                            (customizationFields['body_top_right_barcode'] && barcode) ? {
                                svg: barcode
                            } : '',

                            (customizationFields['body_top_right_challan_number']) ? {
                                text: [
                                    {
                                        text: 'CHALLAN NO: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },

                                    {
                                        text: product.challan_number
                                    }
                                 ]
                            } : '',

                            (customizationFields['body_top_right_challan_date']) ? {
                                text: [
                                    {
                                        text: 'CHALLAN DATE: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },

                                    {
                                        text: formatToDdMmYy(product.challan_date),
                                    }
                                 ]
                            } : '',

                            (customizationFields['body_top_right_order_number']) ? {
                                text: [
                                    {
                                        text: 'Order NO: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },

                                    {
                                        text: product.sales_order ? product.sales_order.bill_number : '-'
                                    }
                                 ]
                            } : '',

                            (customizationFields['body_top_right_order_date']) ? {
                                text: [
                                    {
                                        text: 'Order DATE: ',
                                        bold: true,
                                        margin: [0, 0, 10, 0]
                                    },

                                    {
                                        text: product.sales_order ? product.sales_order.date : '-'
                                    }
                                 ]
                            } : '',

                            (customizationFields['body_top_right_ship_from']) ? {
                                stack: [
                                    {
                                        text: product.location_id ? 'SHIP FROM:' : '',
                                        bold: true
                                    },

                                    {
                                        text: product.business_location ? product.business_location.name : ''
                                    }
                                ]
                            } : ''
                        ]
                    },
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: getChallanTableWidth(customizationFields),
                    body: []
                },
                layout: {
			        fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
		        }
		    },

            {
                columns: [
                    {
                        width: '55%',
                        text: [
                            {
                                text: '',
                                bold: true
                            }
                        ]
                    },
                     {
                        table: {
                            widths: ['*', '*'],
                            alignment: 'right',
                            body: formatTotals(product, customizationFields)
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return 0.5;
                            },
                            vLineWidth: function (i, node) {
                                return 0.5;
                            }
                        }
                    }
                ],
                margin: [0, 10]
            },
            (customizationFields['body_bottom_note'] && product.description) ? {
                alignment: 'justify',
                text: [{ text: 'NOTE: \n', bold: true}, {text: product.description} ]
            } : ''

        ]
    }
    const getFooter = (userName, qrcode, customizationFields) =>{
        return {
            margin: [ 60, 0, 60, 0 ],
            columns: [
                {
                    columns: [
                        (customizationFields['footer_qrcode']) ? {
                            svg: qrcode
                        } : '',

                        (customizationFields['footer_note']) ? {
                            width: '90%',
                            alignment: 'left',
                            text: 'N.B: This is a system generated documents and requires no manual signature.',
                            margin: [5, 53, 0, 0],
                            fontSize: 8
                        } : ''
                    ]
                },

                (customizationFields['footer_printed_by']) ? {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        {
                            text: 'Printed by',
                            bold: true
                        },
                        {
                            text: userName
                        },
                        {
                            text: formatDate(new Date())
                        }
                    ]
                } : ''
            ]
        }
    }

    const challanTableColumnWeights = [
        { field: 'body_table_sl', weight: 5, alwaysOn: false },
        { field: 'body_table_style', weight: 13, alwaysOn: false },
        { field: 'body_table_order_no', weight: 13, alwaysOn: false },
        { field: 'item', weight: 12, alwaysOn: true },
        { field: 'body_table_color', weight: 9, alwaysOn: false },
        { field: 'body_table_size', weight: 7, alwaysOn: false },
        { field: 'body_table_uom', weight: 6, alwaysOn: false },
        { field: 'qty', weight: 6, alwaysOn: true },
        { field: 'body_table_gross_weight', weight: 9, alwaysOn: false },
        { field: 'body_table_net_weight', weight: 9, alwaysOn: false },
        { field: 'body_table_remarks', weight: 11, alwaysOn: false },
    ]

    const getChallanTableWidth = (customizationFields) => {
        const activeColumns = challanTableColumnWeights.filter(function (column) {
            return column.alwaysOn || customizationFields[column.field];
        })
        const totalWeight = activeColumns.reduce(function (sum, column) {
            return sum + column.weight;
        }, 0)
        return activeColumns.map(function (column) {
            return (column.weight / totalWeight * 100).toFixed(2) + '%';
        })
    }

    const formatTotals = (product, customizationFields) => {
        const totals = [];

        if (customizationFields['body_totals_table_total_qty']) {
            totals.push([{ text: 'Total' }, { text: product.total_quantity, alignment: 'right'}]);
        }

        return totals;
    }

    const getProfileItemByField = (profile_items, keyValue) => {
        const item = profile_items.find(item => item.field === keyValue);
        return (item) ? item.value : '';
    }

    let srNumber = 0;
    const pushIntoTable = (doc, product, tableItems, btnFunc, customizationFields) => {
        srNumber = 0;
        var flag = false;
        tableItems.forEach( (item, index) => {
            if( !flag ){
                const tableHeader = getTableHeader(customizationFields);
                doc.content[2].table.body.push(tableHeader);
                flag = true;
            }
            const rowData = getRowData(item, customizationFields);
            return doc.content[2].table.body.push(rowData);
        });
    }

    const getTableHeader = (customizationFields) => {
        let headerInvoice = [];
        if (customizationFields['body_table_sl']) {
            headerInvoice.push({ text: 'SL #' });
        }
        if (customizationFields['body_table_style']) {
            headerInvoice.push({ text: 'Style' });
        }
        if (customizationFields['body_table_order_no']) {
            headerInvoice.push({ text: 'Order Number' });
        }
        headerInvoice = headerInvoice.concat([
            { text: 'Item' },
        ])
        if (customizationFields['body_table_color']) {
            headerInvoice.push({ text: 'Color' });
        }
        if (customizationFields['body_table_size']) {
            headerInvoice.push({ text: 'Size' });
        }
        if (customizationFields['body_table_uom']) {
            headerInvoice.push({ text: 'UoM' });
        }
        headerInvoice = headerInvoice.concat([
            { text: 'Qty' },
        ])
        if (customizationFields['body_table_gross_weight']) {
            headerInvoice.push({ text: 'G.W (KG)' });
        }
        if (customizationFields['body_table_net_weight']) {
            headerInvoice.push({ text: 'N.W (KG)' });
        }
        if (customizationFields['body_table_remarks']) {
            headerInvoice.push({ text: 'Remarks' });
        }

        return headerInvoice;
    }

    const getRowData = (item, customizationFields) => {
        srNumber += 1;
        const brandName = getSpecificationName(item, 0);
        const colorName = getSpecificationName(item, 1);
        const sizeName = getSpecificationName(item, 2);
        const unitNameValue = unitName(item);

        let rowInvoice = [];
        if (customizationFields['body_table_sl']) {
            rowInvoice.push({ text: srNumber });
        }
        if (customizationFields['body_table_style']) {
            rowInvoice.push({ text: (item.sales_order_general ? item.sales_order_general.style : '-') });
        }
        if (customizationFields['body_table_order_no']) {
            rowInvoice.push({ text: (item.sales_order_general ? item.sales_order_general.po_number : '-') });
        }
        rowInvoice = rowInvoice.concat([
            { text: brandName },
        ])
        if (customizationFields['body_table_color']) {
            rowInvoice.push({ text: colorName });
        }
        if (customizationFields['body_table_size']) {
            rowInvoice.push({ text: sizeName });
        }
        if (customizationFields['body_table_uom']) {
            rowInvoice.push({ text: unitNameValue });
        }
        rowInvoice = rowInvoice.concat([
            { text: item ? item.quantity : '', alignment: 'right' },
        ])
        if (customizationFields['body_table_gross_weight']) {
            rowInvoice.push({ text: item ? item.gross_weight : '', alignment: 'right' });
        }
        if (customizationFields['body_table_net_weight']) {
            rowInvoice.push({ text: item ? item.net_weight : '', alignment: 'right' });
        }
        if (customizationFields['body_table_remarks']) {
            rowInvoice.push({ text: item ? item.description : '', alignment: 'right' });
        }

        return rowInvoice;
    }

    const getSpecificationName = (item, index) => {
        if (item && item.product && item.product.specifications && item.product.specifications[index] && item.product.specifications[index].specifiable && item.product.specifications[index].specifiable.name) {
            return item.product.specifications[index].specifiable.name;
        }
        return '-';
    }

    const unitName = (item) => {
        if (item && item.product && item.product.description && item.product.description.unit && item.product.description.unit.name) {
            return item.product.description.unit.name;
        }
        return item.head.name;
    }

    return {
        exportToPDF
    }
}

export default POChallanPdfPrinter;
